import { mergeDeepRight, equals, or, gt, lt } from 'ramda';
import {
  hasNoAnswers,
  generateError,
  generateSuccess
} from './validationHelpers';
import extractMinMaxBound from './minMaxExtractor';
import validationErrorMessageExtractor from './validationErrorMessageExtractor';

const errorText = 'Please provide a numerical answer to the question';

export default function validateNumber(question, answers) {
  if (hasNoAnswers(answers)) {
    return mergeDeepRight(question, generateError(errorText));
  }
  const value = parseInt(answers[0].value, 10);

  if (equals(value.length, 0)) {
    return mergeDeepRight(question, generateError(errorText));
  }
  if (isNaN(value)) {
    return mergeDeepRight(question, generateError(errorText));
  }
  const minMaxBounds = extractMinMaxBound(question.options[0]);
  const validationError = validationErrorMessageExtractor(question.options[0]);

  if (
    minMaxBounds &&
    minMaxBounds.min &&
    or(gt(value, minMaxBounds.max), lt(value, minMaxBounds.min))
  ) {
    return mergeDeepRight(
      question,
      generateError(
        validationError || `Please enter a value between ${minMaxBounds.min} and ${minMaxBounds.max}`
      )
    );
  }
  return mergeDeepRight(question, generateSuccess());
}



// WEBPACK FOOTER //
// ./src/components/questionnaire/validators/validateNumber.js